import { useCallback, useState } from 'react'
import styles from './FrameElement.module.scss'
import { ElementWrapper } from '../components/ElementWrapper/ElementWrapper'
import { updateFramePosition, updateFrameSize, updateFrameTitle } from '../../../store/actions'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { ScoopText } from '../../ui'

export const FrameElement = ({
    id,
    title,
    initialPosition,
    initialSize,
    backgroundColor,
    backgroundImage,
    setShowMenu,
    multiProps,
}) => {
    const frameId = `FrameElement-${id}`
    const dispatch = useDispatch()
    const activeMode = useSelector((state) => state.ui.activeMode)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editTitle, setEditTitle] = useState(false)
    const [frameTitle, setFrameTitle] = useState(title || '')
    const debounceFn = useCallback(
        debounce((value) => {
            dispatch(updateFrameTitle(id, value))
        }, 1000),
        []
    )

    const updateFramePos = (position) => {
        dispatch(updateFramePosition(id, position))
    }

    const updateFrameSz = (size) => {
        dispatch(updateFrameSize(id, size))
    }

    const toggleEditMode = (value) => {
        if (value) setShowMenu(true)
        else setShowMenu(false)
        setIsEditMode(value)
        setEditTitle(false)
    }

    return (
        <ElementWrapper
            id={frameId}
            editMode={isEditMode}
            toggleEditMode={toggleEditMode}
            initialPosition={initialPosition}
            initialSize={initialSize}
            updateElementPosition={updateFramePos}
            updateElementSize={updateFrameSz}
            type={'Frame'}
            {...multiProps}
        >
            <div className={styles.frameContainer} style={{ backgroundColor }}>
                {backgroundImage && (
                    <img
                        src={
                            backgroundImage.url
                                ? backgroundImage.url.replace(
                                      'https://scoop-image-uploads.s3.us-west-2.amazonaws.com',
                                      'https://d3lkv74tdz6isd.cloudfront.net'
                                  ) + '?withHeaders=yes'
                                : backgroundImage.replace(
                                      'https://scoop-image-uploads.s3.us-west-2.amazonaws.com',
                                      'https://d3lkv74tdz6isd.cloudfront.net'
                                  ) + '?withHeaders=yes'
                        }
                        alt={'background'}
                        className={styles.backgroundImage}
                        crossOrigin={'anonymous'}
                    />
                )}
                <div className={styles.frameTitleContainer}>
                    {editTitle ? (
                        <input
                            id={'frame-title-input'}
                            value={frameTitle}
                            onChange={(e) => {
                                setFrameTitle(e.target.value)
                                debounceFn(e.target.value)
                            }}
                            className={styles.editTitleInput}
                            onClick={(e) => e.stopPropagation()}
                        />
                    ) : (
                        <ScoopText
                            onDoubleClick={() => {
                                if (activeMode === 'edit') setEditTitle(true)
                            }}
                            className={styles.frameTitle}
                        >
                            {title}
                        </ScoopText>
                    )}
                </div>
            </div>
        </ElementWrapper>
    )
}
